export const frontmatter = {
    "draft": false,
    "title": "Panel de analíticas",
    "description": "Panel de analíticas y reportes en OnnIA.",
    "sidebar_label": "Descripción general",
    "sidebar_group": "referencia",
    "sidebar_order": 1
}

export const toc = []